import { CustomerVariables } from "../../customerVariables/variable_interfaces";

export function getCustomerVariables() {
    const customerConfigKey = (process.env.REACT_APP_CUSTOMER_CONFIG || 'default').trim();
    const customerVariablesModule: { [key: string]: CustomerVariables } = require(`../../customerVariables/${customerConfigKey}_variables`);
    const customerVariables = customerVariablesModule[`${customerConfigKey}Variables`];
    return customerVariables;
}